import React from "react";
import styled from "styled-components";
import { Button, ButtonClass } from "src/components/ui";
import { theme } from "src/styles/Theme";

const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
`;

const ModalContent = styled.div`
	background: white;
	border-radius: 16px;
	padding: 24px;
	width: 90%;
	max-width: 400px;
	position: relative;
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

const CloseButton = styled.button`
	position: absolute;
	top: 16px;
	right: 16px;
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: #666;
	width: 32px;
	height: 32px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background: #f5f5f5;
	}
`;

const Title = styled.h2`
	text-align: center;
	font-size: 20px;
	font-weight: 600;
	margin-bottom: 20px;
	color: ${(props) => props.theme.colors.text_01};
`;

const Message = styled.p`
	text-align: center;
	font-size: 16px;
	color: #666;
	margin-bottom: 24px;
	line-height: 1.5;
`;

const ActionButtons = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
`;

interface ConfirmApprovalModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isLoading?: boolean;
}

const ConfirmApprovalModal: React.FC<ConfirmApprovalModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	isLoading = false,
}) => {
	if (!isOpen) return null;

	return (
		<ModalOverlay onClick={onClose}>
			<ModalContent onClick={(e) => e.stopPropagation()}>
				<CloseButton onClick={onClose}>×</CloseButton>

				<Title>Approve Request</Title>

				<Message>Are you sure you want to approve this request?</Message>

				<ActionButtons>
					<button
						className='border border-red-500 text-red-500 px-4 py-2 rounded-md w-full'
						onClick={onClose}
						disabled={isLoading}
					>
						No, Go Back
					</button>
					<button
						className='bg-primary text-white px-4 py-2 rounded-md w-full'
						onClick={onConfirm}
						disabled={isLoading}
					>
						{isLoading ? "Processing..." : "Yes, Approve"}
					</button>
				</ActionButtons>
			</ModalContent>
		</ModalOverlay>
	);
};

export default ConfirmApprovalModal;
